import { sendRequest } from "../base.service";

export const getSliderRequest = () => {
  return sendRequest("/home/slider");
};
export const getPartnerSliderRequest = () => {
  return sendRequest("/partner/slider");
};
export const getVSATSliderRequest = () => {
  return sendRequest("/vsat/slider");
};
export const getRetiredSliderRequest = () => {
  return sendRequest("/retired/slider");
};
export const getEnglishSliderRequest = () => {
  return sendRequest("/home/en/slider");
};
